module.exports = __webpack_public_path__ + "img/ic_success.68a7aa14.png";